import 'lazysizes';
import objectFitImages from 'object-fit-images';
import { gsap } from 'gsap';
// import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { SlowMo } from 'gsap/EasePack';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

import './animations';
import './menu';
import './parallax';
import './gallery';
import './im-gallery';
import './testimonials';
import './filter';
import './calculator';
import './profiles';
import './notices';
import './dialog';
import './site-by-brighter';

objectFitImages();

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {

  /**
   * Initialize aria visibility toggles.
   *
   * Usage:
   *    <button aria-expanded="false" aria-controls="myDropdown">Toggle</button>
   *    <div id="myDropdown" aria-hidden="true">Dropdown</div>
   */
  document.querySelectorAll('[aria-expanded][aria-controls]').forEach(el => {
    el.addEventListener('click', e => {
      const id = el.getAttribute('aria-controls');
      const controlled = document.getElementById(id);
      const open = controlled.getAttribute('aria-hidden') !== 'false';

      controlled.setAttribute('aria-hidden', open ? 'false' : 'true');
      controlled.hidden = !open;

      document.querySelectorAll(`[aria-controls="${id}"]`).forEach(el => {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      if (open) {
        el.innerHTML = el.innerHTML.replace('Show', 'Hide');
      } else {
        el.innerHTML = el.innerHTML.replace('Hide', 'Show');
      }

      e.preventDefault();
    });
  });

  // init light gallery
  document.querySelectorAll('.lightgallery').forEach(el => {
    console.log(window['lightGalleryItems' + el.getAttribute('data-id')]);
    // const lgContainer = el.getElementById('inline-gallery-container');
    const inlineGallery = lightGallery(el, {
      plugins: [lgThumbnail],
      speed: 500,
      licenseKey: 'E5D46190-EE13412F-B22CC7F8-29F8C471',

      container: el,
      dynamic: true,
      hash: false,
      closable: false,
      download: false,
      showMaximizeIcon: true,
      allowMediaOverlap: false,
      // controls: false,
      appendSubHtmlTo: '.lg-item',
      dynamicEl: window['lightGalleryItems' + el.getAttribute('data-id')]
    });
    inlineGallery.openGallery();
  });


  // init block links
  document.querySelectorAll('.block-link').forEach(el => {
    el.addEventListener('click', function(e) {
      el.querySelector('a').click();
    });
  });

});

document.addEventListener('scroll', function(e) {
  if (window.scrollY > 0) {
    document.querySelector('#main').classList.add('is-scrolled-off-top');
  } else {
    document.querySelector('#main').classList.remove('is-scrolled-off-top');
  }
});


//* parent portal link replacement =================================================== */

document.addEventListener('DOMContentLoaded', () => {

  if (replaceFileLinks) {

    function isFile(pathname) {
        return pathname.split('/').pop().indexOf('.') > -1;
    }

    function isExternalLink(url) {
        const tmp = document.createElement('a');
        tmp.href = url;
        return tmp.host !== window.location.host;
    };

    var siteUrl = "https://www.concordia.sa.edu.au";
    // var internalLinks = document.querySelectorAll("a[href^='"+siteUrl+"'], a[href^='/'], a[href^='./'], a[href^='../'], a[href^='#']");
    var allLinks = document.querySelectorAll('a');

    // if (allLinks) {
    //   allLinks.forEach(link => {
    //     var url = link.getAttribute('href');
    //     if (isFile(url)) {
    //       link.setAttribute('href', siteUrl + '/view-resource/?url=' + url);
    //     }
    //   });
    // }

  }

});
